var TorsoNestedModel = require('backbone-torso/modules/NestedModel');
var urls = require('./../urls');
var applicationUtils = require('./../applicationUtils');

var STATUSES = {
  STARTED: 'STARTED',
  SENT: 'SENT',
  RECEIVED: 'RECEIVED',
  FINISHED: 'FINISHED',
  ERRORED: 'ERRORED'
};

var PAYMENT_MODALITY_APPLICATION_MAPPING = {
  KIOSK: 'KIOSK',
  ADMIN_TOOL: 'ADMIN_TOOL',
  PATIENT_PORTAL: 'PATIENT_PORTAL',
  EREG: 'EREG'
};

/**
 * Model used to create and track a payment transaction.
 *
 * @class PaymentTransactionModel
 * @constructor
 */
var PaymentTransactionModel = TorsoNestedModel.extend({
  urlRoot: urls.paymentTransactionExtService,
  idAttribute: 'vecnaId',
  STATUSES: STATUSES,
  defaults: {
    paymentApplication: PAYMENT_MODALITY_APPLICATION_MAPPING[applicationUtils.currentApplication]
  },

  /**
   * copy the sensitive payment data from other payment transaction model.
   * @param otherPaymentTransactionModel {PaymentTransactionModel} - the model to copy the data from.
   */
  copySensitiveData: function(otherPaymentTransactionModel) {
    if (!otherPaymentTransactionModel) {
      return;
    }
    this.set('request', otherPaymentTransactionModel.get('request'));
  }
});

PaymentTransactionModel.STATUSES = STATUSES;

module.exports = PaymentTransactionModel;
